import Vue from 'vue'
import moment from 'moment'

Vue.mixin({
    methods: {
        momentFromNow(value) {
            return value ? moment(value).fromNow() : null
        }
    }
})